<template>
    <div class="messenger">
        <slot :messages="messages"></slot>
        <template v-for="(modal, modalId) in modals">
            <div class="modal" :id="'messengerModal' + modalId" tabindex="-1" role="dialog">
                <div :class="'modal-dialog modal-' + modal.size" role="document">
                    <div class="modal-content">
                        <div class="modal-header" v-if="modal.showHeader">
                            <h5 class="modal-title" v-html="modal.title"></h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="modal.showClose">
                                <span aria-hidden="true"><i class="fal fa-fw fa-times"></i></span>
                            </button>
                        </div>
                        <div class="modal-body" v-html="modal.body"></div>
                        <div class="modal-footer" v-if="modal.showFooter">
                            <template v-for="button in modal.buttons">
                                <button :class="'btn btn-' + button.type" v-html="button.content" @click="button.callback"></button>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';

export default {
    props: {
        messages: {},
        listen: {
            default: false,
        },
    },
    data() {
        return {
            modals: {},
        };
    },
    created() {
        if (this.listen) {
            Bus.$on('newMessengerMessages', this.processMessages);
        }

        Bus.$on('newMessengerModal', this.processModal);
    },
    beforeDestroy() {
        if (this.listen) {
            Bus.$off('newMessengerMessages', this.processMessages);
        }

        Bus.$off('newMessengerModal', this.processModal);
    },
    methods: {
        processModal({ id, modal }) {
            if (_.isString(modal)) {
                //modal actions here
            } else {
                this.makeModal(id, modal);
                this.$nextTick(() => {
                    $('#messengerModal' + id).modal('show');
                });
            }
        },
        makeModal(id, modal) {
            modal.buttons = this.makeModalButtons(modal);
            modal.body = this.makeModalSection(modal.body);
            Vue.set(
                this.modals,
                id,
                _.merge(
                    {
                        showHeader: true,
                        showFooter: true,
                        showClose: true,
                        body: '',
                        title: '',
                        size: 'md',
                    },
                    modal,
                ),
            );
        },
        makeModalSection(section) {
            if (_.isString(section)) {
                return section;
            }
            let ComponentClass = Vue.extend(section);
            let instance = new ComponentClass();
            instance.$mount();
            return instance.$el.innerHTML;
        },
        makeModalButtons(modal) {
            return _.map(modal.buttons, (button) => {
                return _.merge(
                    {
                        type: 'default',
                        content: null,
                        callback: () => ({}),
                    },
                    button,
                );
            });
        },
        processMessages(messages) {
            if (!this.processRedirects(messages)) {
                Promise.all([this.processToast(messages), this.processOverlay(messages)]).then((data) => {
                    Bus.$emit('messengerMessagesComplete', data);
                });
            }
        },
        processRedirects(messages) {
            let redirected = false;
            _.chain(messages)
                .filter((message) => {
                    return _.includes(['redirect'], message.type);
                })
                .value()
                .forEach((message) => {
                    redirected = true;
                    window.location = message.message;
                });

            return redirected;
        },
        processToast(messages) {
            return new Promise((resolve) => {
                _.chain(messages)
                    .filter((message) => {
                        return _.includes(['toast', 'alert', 'message'], message.type);
                    })
                    .value()
                    .forEach((message) => {
                        this.$noty.show(message.message, message.level);
                    });

                resolve(messages);
            });
        },
        processOverlay(payload) {
            let queue = _.chain(payload)
                .filter((message) => {
                    return _.includes(['overlay', 'popup'], message.type);
                })
                .map((message) => {
                    return {
                        title: message.message,
                        html: message.html,
                        type: message.level,
                        confirmButtonClass: 'btn btn-secondary',
                        buttonsStyling: false,
                        showCancelButton: false,
                        showConfirmButton: message.confirm,
                        confirmButtonText: 'Ok',
                    };
                })
                .value();

            return new Promise((resolve) => {
                if (queue.length) {
                    swal.queue(queue).then((result) => {
                        resolve(result);
                    });
                } else {
                    resolve(payload);
                }
            });
        },
    },
    watch: {
        messages: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.$nextTick(() => {
                    this.processMessages(newVal);
                });
            },
        },
    },
};
</script>
